module.exports = __webpack_public_path__ + "img/Location Icon - white.09d3e8db.svg";